import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AppLoaderNavigationService } from '../services/app-loader-navigation.service';

export const appLoaderTitleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot): Observable<string> => {
  const appLoaderNavigationService = inject(AppLoaderNavigationService);
  const code = route.paramMap.get('code');

  return appLoaderNavigationService.resolveNavigationItem(code).pipe(
    map(navigationItem => {
      // Use navigation item Value property as the title
      return navigationItem?.Value || '';
    })
  );
};
